import { Environments, AppEnvironment } from '../models';
const { Environment } = require('../buildSettings.json');

/**
 * Get site environment (one of 'localhost' | 'dev' | 'stg' | 'prod')
 * @param {string} origin string
 * @returns {Environments} Environments
 */

// Refactored to take an optional environmentOverride parameter
// This makes testing easier
export const getEnvironment = (environmentOverride = Environment as string): Environments => {
  switch (environmentOverride) {
    case 'Development':
      return AppEnvironment.Dev;
    case 'UAT':
      return AppEnvironment.UAT;
    case 'Production':
      return AppEnvironment.Production;
    case 'Local':
    default:
      return AppEnvironment.Local;
  }
};

export const environmentLabels = {
  localhost: 'Local',
  dev: 'Dev',
  stg: 'UAT',
  prod: 'Production'
};
